import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    console.log("default ", process.env.REACT_APP_DEFAULTAUTH);
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      );
      yield put(loginSuccess(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      console.log("user: ", user);
      const authUser = {
        token: user.token,
        username: user.name,
        user: {
          email: user.email,
          picture: user.picture,
          sub: user.sub
        }
      };
      
      localStorage.setItem("authUser", JSON.stringify(authUser));
      yield put(loginSuccess(authUser));
      history('/maindash');
      // const response = yield call(postFakeLogin, {
      //   email: user.email,
      //   password: user.password,
      // });
      // localStorage.setItem("authUser", JSON.stringify(response));
      // console.log("response: ", response);
      // yield put(loginSuccess(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "auth0") {
      console.log("auth: ", user);
      const authUser = {
        token: user.token,
        username: user.name,
        user: {
          email: user.email,
          picture: user.picture,
          sub: user.sub
        }
      };
      
      localStorage.setItem("authUser", JSON.stringify(authUser));
      yield put(loginSuccess(authUser));
      history('/maindash');
    }
    else{
      console.log("auth: ", user);
      const authUser = {
        token: user.token,
        username: user.name,
        user: {
          email: user.email,
          picture: user.picture,
          sub: user.sub
        }
      };
      
      localStorage.setItem("authUser", JSON.stringify(authUser));
      yield put(loginSuccess(authUser));
      history('/maindash');
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const domain = process.env.REACT_APP_AUTH0_DOMAIN;
      const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
      const returnTo = window.location.origin;
      
      // Clear localStorage first
      localStorage.removeItem("authUser");
      
      // Update Redux state
      yield put(logoutUserSuccess());
      
      // Construct the Auth0 logout URL with all necessary parameters
      const logoutUrl = new URL(`https://${domain}/v2/logout`);
      logoutUrl.searchParams.append('client_id', clientId);
      logoutUrl.searchParams.append('returnTo', returnTo + '/login');
      
      // Redirect to Auth0 logout
      window.location.replace(logoutUrl.toString());
    } else {
      history('/login');
    }
  } catch (error) {
    yield put(apiError(error));
  }
}



function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        history("/maindash");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    if(response)
    history("/maindash");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
